query WidgetsList($page: Int, $rowsPerPage: Int) {
  widgets(page: $page, rowsPerPage: $rowsPerPage) {
    count
    nodes {
      id
      title
      buttonUrl
      buttonText
      buttonColor
      buttonTextColor
      hits
      clicks
      ctr
      isDefault
      createdAt
    }
  }
}
